import { useEffect } from 'react'
import { useNavigate } from 'react-router'

export const AuthPage = () => {
  const navigate = useNavigate()

  useEffect(() => { 
    navigate('/auth/login')
  }, [navigate])

  return null
}
